<script setup lang="ts">
  import type { TrainingDetail } from '@/entities/Training';
  import TrainingViewCertificateFields from '../view/TrainingViewCertificateFields.vue';

  defineProps<{
    certificate: TrainingDetail['certificate'];
  }>();
</script>

<template>
  <section
    data-testid="training-control-section-certificate"
    class="flex flex-col gap-4 border-b border-gray-02 px-6 py-8"
  >
    <TrainingViewCertificateFields :certificate="certificate" />
  </section>
</template>
